var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomepageValuePropCTA/HomepageValuePropCTA.jsx";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Heading, IconArrowRight } from '@zillow/constellation';
import { useYieldCallback } from '@zillow/yield-callback';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
import { ImageWithProgress, ListItemWithProgress, ColumnImage } from './ProgressTracker';
import { action } from '../../../../../eventing/eventHandlers';
import { imageSrc } from '../utils/helper';
export var HomepageValuePropCTA = function HomepageValuePropCTA(_ref) {
  var heading = _ref.heading,
      firstSubHeading = _ref.firstSubHeading,
      firstParagraph = _ref.firstParagraph,
      secondSubHeading = _ref.secondSubHeading,
      secondParagraph = _ref.secondParagraph,
      thirdSubHeading = _ref.thirdSubHeading,
      thirdParagraph = _ref.thirdParagraph,
      buttonText = _ref.buttonText,
      animationTime = _ref.animationTime,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      firstImageMedia = _ref.firstImageMedia,
      secondImageMedia = _ref.secondImageMedia,
      thirdImageMedia = _ref.thirdImageMedia,
      additionalProps = _ref.additionalProps;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      skipAnimation = _useState2[0],
      setSkipAnimation = _useState2[1];

  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeNumber = _useState4[0],
      setActiveNumber = _useState4[1];

  var intervalId = useRef(undefined);
  useEffect(function () {
    intervalId.current = setInterval(function () {
      setActiveNumber(function (prevActiveNumber) {
        return (prevActiveNumber + 1) % 3;
      });
    }, 1000 * animationTime);
    return function () {
      clearInterval(intervalId.current);
      intervalId.current = undefined;
    };
  }, []);
  var onPropClick = useYieldCallback(function (propNumber) {
    setSkipAnimation(true);
    setActiveNumber(propNumber);
    clearInterval(intervalId.current);
    intervalId.current = undefined;
  }, [intervalId.current]);
  var onAction = additionalProps.onAction;
  var defaultEventData = {
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  };
  var onClickArgs = Object.assign(Object.assign({}, defaultEventData), {}, {
    onAction: onAction
  });
  var onClickAction = useYieldCallback(function () {
    action(onClickArgs);
  }, [action].concat(_toConsumableArray(Object.values(onClickArgs))));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      'gap': '$spacing.sm',
      'display': 'grid',
      'gridTemplateColumns': '1fr',
      '@media $lg_gte': {
        gap: '$spacing.md',
        gridTemplateColumns: '1fr 1fr'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Heading,
    level: "3",
    fontType: {
      default: 'h4',
      xl_gte: 'h3'
    },
    sx: {
      paddingBottom: '$spacing.lg'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 21
    }
  }, heading), /*#__PURE__*/React.createElement(Box, {
    sx: {
      'display': 'flex',
      'gap': '$spacing.lg',
      'flex-direction': 'column',
      'margin-right': '$spacing.none',
      '@media $xl_gte': {
        'margin-right': '15%'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 21
    }
  }, [{
    subheading: firstSubHeading,
    paragraph: firstParagraph,
    img: firstImageMedia
  }, {
    subheading: secondSubHeading,
    paragraph: secondParagraph,
    img: secondImageMedia
  }, {
    subheading: thirdSubHeading,
    paragraph: thirdParagraph,
    img: thirdImageMedia
  }].map(function (_ref2, index) {
    var subheading = _ref2.subheading,
        paragraph = _ref2.paragraph,
        img = _ref2.img;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: subheading,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(ListItemWithProgress, {
      heading: subheading,
      paragraph: paragraph,
      active: activeNumber === index,
      animationTime: animationTime,
      onClick: function onClick() {
        return onPropClick(index);
      },
      skipAnimation: skipAnimation,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(ColumnImage, {
      active: activeNumber === index,
      media: img,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 134,
        columnNumber: 33
      }
    }));
  })), /*#__PURE__*/React.createElement(Box, {
    as: Button,
    sx: {
      marginTop: '$spacing.lg !important'
    },
    buttonType: "primary",
    iconPosition: "end",
    icon: /*#__PURE__*/React.createElement(IconArrowRight, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145,
        columnNumber: 31
      }
    }),
    onClick: onClickAction,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 21
    }
  }, buttonText)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      'position': 'relative',
      'justifyContent': 'end',
      'alignItems': 'center',
      'display': 'none',
      '@media $lg_gte': {
        display: 'flex'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 17
    }
  }, [firstImageMedia, secondImageMedia, thirdImageMedia].map(function (image, index) {
    return /*#__PURE__*/React.createElement(ImageWithProgress, {
      key: imageSrc(image, index),
      active: activeNumber === index,
      media: image,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 25
      }
    });
  }))));
};
HomepageValuePropCTA.defaultProps = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  additionalProps: {}
};
HomepageValuePropCTA.propTypes = process.env.NODE_ENV !== "production" ? {
  heading: PropTypes.string.isRequired,
  firstSubHeading: PropTypes.string.isRequired,
  firstParagraph: PropTypes.string.isRequired,
  secondSubHeading: PropTypes.string.isRequired,
  secondParagraph: PropTypes.string.isRequired,
  thirdSubHeading: PropTypes.string.isRequired,
  thirdParagraph: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  animationTime: PropTypes.number.isRequired,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalProps: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  firstImageMedia: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  secondImageMedia: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  thirdImageMedia: PropTypes.object,

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};